import MobileCloseButton from '@Assets/icons/previous-chevron-small.svg'
import './close-button.scss'

export type CloseButtonProps = {
  backgroundColor?: string
  className?: string
  onClick: () => void
}

const CLASS_NAME = 'close-button'

export const CloseButton = ({ className, onClick }: CloseButtonProps) => {
  return (
    <button
      className={className ? `${CLASS_NAME} ${className}` : `${CLASS_NAME}`}
      tabIndex={0}
      onClick={onClick}>
      <img aria-label="Close" src={MobileCloseButton} />
    </button>
  )
}
